<template>
  <b-container fluid class="realisations">
    <b-row>
      <b-col md="4" sm="12">
        <div class="realisations-menu">
          <Navbar class="d-none d-md-flex"></Navbar>
          <div class="tags mt-md-4">
            <a v-on:click="setTag('')" v-bind:class="{ selected: selectedTag === '' }">
              #toutes
            </a>
            <a v-for="tag in tags" :key="tag" v-on:click="setTag(tag)"
               v-bind:class="{ selected: selectedTag === tag }">
              #{{tag}}
            </a>
          </div>
        </div>
      </b-col>
      <b-col md="8" sm="12">
        <div v-masonry column-width=".grid-sizer"
             gutter=".gutter-sizer" percent-position="true"
             transition-duration="0.3s" item-selector=".carte">
          <div v-masonry-tile class="grid-sizer"></div>
          <div v-masonry-tile class="gutter-sizer"></div>
          <a v-masonry-tile class="carte" v-for="(carte, index) in getCartes"
             :key="carte.name+index" @click="openGallery(index)"
             v-b-tooltip.hover :title="carte.name">
            <img :src="carte.preview"/>
          </a>
        </div>
      </b-col>
    </b-row>
    <LightBox :media="getCartes"
              ref="lightbox"
              :disableScroll="false"
              :show-caption="true"
              :show-light-box="false"></LightBox>
  </b-container>
</template>

<script>
import LightBox from 'vue-image-lightbox';
import Navbar from '@/components/Navbar.vue';
import Constants from '@/constants';

export default {
  components: {
    Navbar,
    LightBox,
  },
  methods: {
    setTag(tag) {
      this.selectedTag = tag;
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    },
  },
  computed: {
    getCartes() {
      if (!this.selectedTag) {
        return this.cartes;
      }
      return this.cartes.filter(carte => carte.tags.includes(this.selectedTag));
    },
  },
  data() {
    return {
      cartes: Constants.cartes.map(carte => ({
        ...carte,
        ...{
          thumb: carte.thumb || carte.preview || carte.src,
        },
      })),
      tags: Constants.tags,
      selectedTag: '',
    };
  },
};
</script>

<style lang="scss" scoped>
  .tags {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    @media (max-width: 768px) {
      flex-direction: row;
      margin-bottom: 1rem;
      a:not(:last-child) {
        margin-right: 1em;
      }
    }
    align-items: flex-start;
    a {
      color: $color-black;
      cursor: pointer;
      &.selected {
        color: $color-yellow;
      }
    }
  }
  a {
    font-family: "Robotoo";
    font-weight: $font-weight-light;
  }
  .realisations-menu {
    @media (max-width: 768px) {
      position: unset;
    }
    position: fixed;
  }

  .grid-sizer {
    width: 32.33%;
    @media (max-width: 768px) {
      width: 49.5%;
    }
    @media (max-width: 576px) {
      width: 100%;
    }
  }
  .gutter-sizer {
    width: 1.5%;
    @media (max-width: 768px) {
      width: 1%;
    }
    @media (max-width: 576px) {
      width: 0%;
    }
  }
  .carte {
    margin-bottom: 1.5%;
    width: 32%;
    @media (max-width: 768px) {
      width: 49.5%;
      margin-bottom: 1%;
    }
    @media (max-width: 576px) {
      width: 100%;
      margin-bottom: 8px;
    }
    img {
      cursor: pointer;
      width: 100%;
      opacity: 1;
      transition: .1s opacity;
      &:hover {
        opacity: 0.8;
      }
    }
  }
</style>
